import { app } from '../../../../../app';
import { Controller } from './approval-forms-list.controller';

app.component('requestCenterApprovalFormsList', {
    bindings: {
        approvalForms: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./approval-forms-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/list/approval-forms-list.component.js